export const ROOT = 'StepTwo/channelPublication/extracharge';

export const SET_EXTRACHARGE = `${ROOT}/SET_EXTRACHARGE`;
export const SET_EXTRACHARGE_ALL = `${ROOT}/SET_EXTRACHARGE_ALL`;
export const SET_VIGNETTE_VALUE = `${ROOT}/SET_VIGNETTE_VALUE`;

export const SELECT_EXTRACHARGE = `${ROOT}/SELECT_EXTRACHARGE`;

export const CLEAR_EXTRACHARGE_ALL = `${ROOT}/CLEAR_EXTRACHARGE_ALL`;
export const CLEAR_EXTRACHARGE = `${ROOT}/CLEAR_EXTRACHARGE`;
export const CLEAR_VIGNETTE_VALUE = `${ROOT}/CLEAR_VIGNETTE_VALUE`;

export const DELETE_EXTRACHARGE_DATA = `${ROOT}/DELETE_EXTRACHARGE_DATA`;